import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'

@InputType()
export class RevokeOrderDocumentLinksArgs extends ActionArgs {
  @Field(() => ID)
  orderId: string
}

// TResult is the number of links revoked
export interface IRevokeOrderDocumentLinks extends IAction<number, RevokeOrderDocumentLinksArgs> {}
